import * as React from 'react'
import styled from 'styled-components/macro'
import ArrowIcon from 'icons/arrow'
import CollapseIcon from 'icons/collapse-arrow'
import Floor6 from 'floor-planes/floor6'
import Floor7 from 'floor-planes/floor7'
import Floor8 from 'floor-planes/floor8'
import Floor9 from 'floor-planes/floor9'
import Floor10 from 'floor-planes/floor10'
import Floor11 from 'floor-planes/floor11'
import Floor12 from 'floor-planes/floor12'
import Floor13 from 'floor-planes/floor13'
import Floor14 from 'floor-planes/floor14'
import { BUILDING_B_DATA } from 'data/buildingB'

const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 15px;
  width: 510px;
  border-radius: 5px 5px 0 0;
  padding: 10px;
  background-color: rgba(134, 207, 194, 0.9);

  @media (max-width: 575px) {
    right: 0;
    left: 0;
    width: auto;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    width: 300px;
  }
`

const CollapsibleWrapper = styled.div`
  /* width: 900px; */
  margin: 0 auto;

  input[type='checkbox'] {
    display: none;
  }
`

const Label = styled.label`
  display: block;
  width: 100%;
  text-align: center;
  position: relative;
`

const CollapsibleContent = styled.div`
  max-height: ${p => (p.collapse ? 'auto' : '100%')};
  overflow: hidden;
  transition: max-height 0.2s ease;
  text-align: center;
`

const ApartmentInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    min-width: 50px;
    margin: 0;
    padding: 10px 20px;
    color: #c2e5dd;
  }

  .floor {
    background-color: #004a33;
  }

  .apartment {
    min-width: 120px;
    margin-right: 0;
    background-color: #537f6e;
  }

  @media (max-width: 575px) {
    p {
      padding: 5px 10px;
      font-size: 12px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    p {
      padding: 5px;
      font-size: 10px;
    }

    .floor {
      min-width: 50px;
    }

    .apartment {
      min-width: 90px;
      margin-right: 0;
      background-color: #537f6e;
    }
  }
`

const ElevatorIcons = styled.div`
  display: flex;
  margin-right: 2rem;
  padding-top: 5px;

  @media (max-width: 575px) {
    margin-right: 1rem;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    margin-right: 14px;
  }
`
const ApartmentIcons = styled.div`
  display: flex;
  margin-left: 2rem;
  padding-top: 5px;

  @media (max-width: 575px) {
    margin-left: 1rem;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    margin-left: 14px;
  }
`

const Disclaimer = styled.div`
  position: absolute;
  bottom: 7px;
  margin-left: 15px;
  opacity: 0.9;
  font-family: BonavaSansMedium;
  color: #537f6e;
`

function Collapsible({ children, collapse, setCollapse }) {
  return (
    <CollapsibleWrapper>
      <input
        id="collapsible"
        className="toggle"
        type="checkbox"
        checked={collapse}
        onChange={() => setCollapse(!collapse)}
      />
      <Label htmlFor="collapsible">
        <div
          style={{
            position: 'absolute',
            bottom: '10px',
            left: '50%',
            padding: '0 10px',
            borderRadius: '5px 5px 0 0',
            transform: 'translateX(-50%)',
            backgroundColor: 'rgba(134, 207, 194, 0.9)',
          }}
        >
          <CollapseIcon collapse={collapse} />
        </div>
      </Label>
      <CollapsibleContent collapse={collapse}>{children}</CollapsibleContent>
    </CollapsibleWrapper>
  )
}

const initialApartment = {
  floor: 14,
  building: 'B',
  apartmentNumber: 87,
  sceneName: 'scene_B87_14_krs',
  name: 'B87',
  relatedApartments: { 13: 83 },
}

export default function NavigationPanel({ krpano, hLookAt, apartmentsCMS }) {
  const [activeFloor, setActiveFloor] = React.useState(initialApartment.floor)
  const [activeApartment, setActiveApartment] = React.useState(initialApartment)
  const [collapse, setCollapse] = React.useState(false)
  const [index, setIndex] = React.useState(undefined)
  const [isSceneName2020, setIsSceneName2020] = React.useState(false)
  const floors = Object.keys(BUILDING_B_DATA)

  React.useEffect(() => {
    if (
      window.matchMedia('(orientation: landscape)').matches &&
      window.matchMedia('(max-device-width: 667px)').matches
    ) {
      setCollapse(true)
    } else {
      setCollapse(false)
    }
  }, [])

  const loadScene = React.useCallback(
    sceneName => {
      if (krpano) {
        const hlookat = krpano.get('view.hlookat')
        const vlookat = krpano.get('view.vlookat')
        const fov = krpano.get('view.fov')
        const distortion = krpano.get('view.distortion')

        krpano.call(
          `loadscene(${sceneName}, null, MERGE, BLEND(0.5, easeInCubic))`,
        )

        krpano.set('view.hlookat', hlookat)
        krpano.set('view.vlookat', vlookat)
        krpano.set('view.fov', fov)
        krpano.set('view.distortion', distortion)
      }
    },
    [krpano],
  )

  const changeView = React.useCallback(
    (floorNumber, aptNumber) => {
      const apartment = BUILDING_B_DATA[floorNumber].find(
        e => e.apartmentNumber === aptNumber,
      )
      const sceneName = isSceneName2020
        ? apartment.sceneName_2020
        : apartment.sceneName
      setActiveApartment(apartment)
      loadScene(sceneName)
    },
    [isSceneName2020, loadScene],
  )

  const changeFloor = navCase => {
    const { apartmentNumber, relatedApartments, floor } = activeApartment
    const targetedFloor = changeActiveFloor(navCase) || floor
    const targetedApartmentNumber =
      relatedApartments[targetedFloor] || apartmentNumber

    changeView(targetedFloor, targetedApartmentNumber)
  }

  const changeActiveFloor = navCase => {
    let targetedFloor

    if (navCase === 'up' && activeFloor < Number(floors[floors.length - 1])) {
      targetedFloor = activeFloor + 1
      setActiveFloor(targetedFloor)
    }
    if (navCase === 'down' && activeFloor > Number(floors[0])) {
      targetedFloor = activeFloor - 1
      setActiveFloor(targetedFloor)
    }
    return targetedFloor
  }

  const changeApartInCollapsible = navCase => {
    const apartments = Object.values(BUILDING_B_DATA[activeFloor]).map(
      e => e.apartmentNumber,
    )
    const { apartmentNumber } = activeApartment
    const apartmentIndex = apartments.indexOf(apartmentNumber)

    if (navCase === 'next' && apartmentIndex < apartments.length - 1) {
      setIndex(apartmentIndex + 1)
      changeView(activeFloor, apartments[apartmentIndex + 1])
    }
    if (navCase === 'previous' && apartmentIndex > 0) {
      changeView(activeFloor, apartments[apartmentIndex - 1])
      setIndex(apartmentIndex - 1)
    }
  }

  React.useEffect(() => {
    // Initialize first view
    changeView(activeFloor, activeApartment.apartmentNumber)
  }, [activeApartment.apartmentNumber, activeFloor, changeView])

  const toggleSceneName2020 = () => setIsSceneName2020(!isSceneName2020)

  const floorPlanProps = {
    activeApartment,
    changeFloor,
    changeView,
    hLookAt,
    toggleSceneName2020,
    isSceneName2020,
  }

  return (
    <Wrapper>
      <Collapsible collapse={collapse} setCollapse={setCollapse}>
        {collapse ? (
          <ApartmentInfo>
            <ElevatorIcons>
              <div style={{ marginRight: '10px' }}>
                <ArrowIcon
                  onClick={() => changeFloor('up')}
                  disabled={activeFloor === Number(floors[floors.length - 1])}
                />
              </div>
              <div>
                <ArrowIcon
                  rotateDeg="180deg"
                  onClick={() => changeFloor('down')}
                  disabled={activeFloor === Number(floors[0])}
                />
              </div>
            </ElevatorIcons>
            <p className="floor">Kerros {activeApartment.floor}</p>
            <p className="apartment">Huoneisto {activeApartment.name}</p>
            <ApartmentIcons>
              <div style={{ marginRight: '10px' }}>
                <ArrowIcon
                  rotateDeg="-90deg"
                  onClick={() => changeApartInCollapsible('next')}
                  disabled={index === 3}
                />
              </div>
              <div>
                <ArrowIcon
                  rotateDeg="90deg"
                  onClick={() => changeApartInCollapsible('previous')}
                  disabled={index === 0}
                />
              </div>
            </ApartmentIcons>
          </ApartmentInfo>
        ) : (
          <div>
            <Disclaimer>Alustava mallinnus ympäröivästä maisemasta</Disclaimer>
            <SwitchComponents active={activeFloor}>
              <Floor6 floor={6} {...floorPlanProps} />
              <Floor7 floor={7} {...floorPlanProps} />
              <Floor8 floor={8} {...floorPlanProps} />
              <Floor9 floor={9} {...floorPlanProps} />
              <Floor10 floor={10} {...floorPlanProps} />
              <Floor11 floor={11} {...floorPlanProps} />
              <Floor12 floor={12} {...floorPlanProps} />
              <Floor13 floor={13} {...floorPlanProps} />
              <Floor14 floor={14} {...floorPlanProps} />
            </SwitchComponents>
          </div>
        )}
      </Collapsible>
    </Wrapper>
  )
}

function SwitchComponents({ active, children }) {
  return children.filter(child => child.props.floor === active)
}
